import $ from 'jquery';

import widgetFactory from '../widgetFactory';
import textInput from './textInput';
import elementError from './elementError';
import elementLoading from './elementLoading';

const widgetName = 'textInputValidate';

export default widgetFactory(widgetName, {
  options: {
    onBeforeValidating: $.noop,
    onAfterValidating: $.noop,
    async: false,
  },

  _create() {
    this._super(widgetName);

    this.errorWidget = elementError.create(this.element);

    textInput.create(
      {
        onChange: (e, { value }) => {
          this.validate(value);
        },
      },
      this.element
    );

    if (this.options.async) {
      this.element.loadingWidget = elementLoading.create(this.element);
    }
  },

  /**
   * @param value
   */
  validate(value) {
    const { async } = this.options;

    this.errorWidget.hide();

    if (async) {
      this.element.loadingWidget.show();
    }

    this._trigger('onBeforeValidating');

    this._validator(value)
      .catch(this._onHandleError.bind(this))
      .finally(() => {
        if (async) {
          this.element.loadingWidget.hide();
        }
        this._trigger('onAfterValidating');
      });
  },

  /**
   * @private
   */
  _validator() {
    throw new Error('need implementation, need to return a promise');
  },

  /**
   * @param {error} error
   * @private
   */
  _onHandleError(error) {
    this.errorWidget.setMessage(error.message).show();
  },
});
